// tslint:disable:no-bitwise whitespace prefer-const curly
// sha256pure: fallback for non-secure contexts (plain-HTTP IP addresses) where
// window.crypto.subtle is unavailable. Produces identical output to crypto.subtle.
function sha256pure(str: string): string {
	const K = [
		0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5, 0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
		0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3, 0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
		0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc, 0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
		0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7, 0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
		0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13, 0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
		0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3, 0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
		0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5, 0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
		0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208, 0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2,
	]
	let h = [0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a, 0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19]
	const rr = (x: number, n: number) => (x >>> n) | (x << (32 - n))

	const bytes: number[] = []
	for (let i = 0; i < str.length; i++) {
		const c = str.charCodeAt(i)
		if (c < 0x80) bytes.push(c)
		else if (c < 0x800) bytes.push(0xC0 | (c >> 6), 0x80 | (c & 0x3F))
		else bytes.push(0xE0 | (c >> 12), 0x80 | ((c >> 6) & 0x3F), 0x80 | (c & 0x3F))
	}
	const bitLen = bytes.length * 8
	bytes.push(0x80)
	while (bytes.length % 64 !== 56) bytes.push(0)
	for (let i = 56; i >= 0; i -= 8) bytes.push((bitLen / Math.pow(2, i)) & 0xFF)

	for (let o = 0; o < bytes.length; o += 64) {
		const w: number[] = new Array(64).fill(0)
		for (let i = 0; i < 16; i++)
			w[i] = bytes[o + i*4] << 24 | bytes[o + i*4+1] << 16 | bytes[o + i*4+2] << 8 | bytes[o + i*4+3]
		for (let i = 16; i < 64; i++) {
			const s0 = rr(w[i-15], 7) ^ rr(w[i-15], 18) ^ (w[i-15] >>> 3)
			const s1 = rr(w[i-2], 17) ^ rr(w[i-2], 19) ^ (w[i-2] >>> 10)
			w[i] = (w[i-16] + s0 + w[i-7] + s1) | 0
		}
		let [a, b, c, d, e, f, g, h7] = h
		for (let i = 0; i < 64; i++) {
			const t1 = (h7 + (rr(e,6) ^ rr(e,11) ^ rr(e,25)) + ((e & f) ^ (~e & g)) + K[i] + w[i]) | 0
			const t2 = ((rr(a,2) ^ rr(a,13) ^ rr(a,22)) + ((a & b) ^ (a & c) ^ (b & c))) | 0
			h7 = g; g = f; f = e; e = (d + t1) | 0; d = c; c = b; b = a; a = (t1 + t2) | 0
		}
		h[0] = (h[0]+a)|0; h[1] = (h[1]+b)|0; h[2] = (h[2]+c)|0; h[3] = (h[3]+d)|0
		h[4] = (h[4]+e)|0; h[5] = (h[5]+f)|0; h[6] = (h[6]+g)|0; h[7] = (h[7]+h7)|0
	}
	return h.map(v => (v >>> 0).toString(16).padStart(8, '0')).join('')
}

export async function sha256hex(str: string): Promise<string> {
	if (window.crypto?.subtle) {
		const buf = new TextEncoder().encode(str)
		const hashBuf = await window.crypto.subtle.digest('SHA-256', buf)
		return Array.from(new Uint8Array(hashBuf)).map(b => b.toString(16).padStart(2, '0')).join('')
	}
	return sha256pure(str)
}
